import React, { memo } from 'react'
import { Display } from 'transfix-ui/components/Display'
import { DraggableListItem } from 'transfix-ui/components/DraggableList'
import Box from 'transfix-ui/core/Box'
import Skeleton from 'transfix-ui/core/Skeleton'

export const ShipmentStopListItemSkeleton = memo(({ index }: { index: number }) => {
  return (
    <DraggableListItem index={index} draggableId={index.toString()} draggable={false}>
      <Box display='flex' width='100%' alignItems='flex-start' justifyContent='space-between'>
        <Box flex='0 0 auto' mr={4} height='100%' display='flex' alignSelf='center'>
          <Skeleton variant='rectangular' width='1em' height='1em' />
        </Box>
        <Box flex='0 0 auto' mr={4} mb={-2}>
          <Display label={<Skeleton variant='rectangular' width='8em' height={17} />}>
            <Box display='flex' alignItems='center' mt={0.5}>
              <Box mr={1}>
                <Skeleton variant='circular' width={24} height={24} />
              </Box>
              <Box mb='2px'>
                <Skeleton variant='rectangular' width={41} height={17} />
              </Box>
            </Box>
          </Display>
        </Box>
        <Box flex='1 1 auto' mr={3} mb={-2}>
          <Display label={<Skeleton variant='rectangular' width='8em' height={17} />}>
            <Box mb='2px'>
              <Skeleton variant='rectangular' width={115} height={17} />
            </Box>
            <Box mb='2px'>
              <Skeleton variant='rectangular' width={270} height={14} />
            </Box>
          </Display>
        </Box>
        <Box flex='1 1 auto' mr={0} mb={-2}>
          <Display label={<Skeleton variant='rectangular' width='8em' height={17} />}>
            <Box mb='2px'>
              <Skeleton variant='rectangular' width={115} height={17} />
            </Box>
          </Display>
        </Box>
      </Box>
    </DraggableListItem>
  )
})
